export default __webpack_public_path__ + "static/media/feature-square-little.5a1c55ac.png";